import React, { useState } from 'react';
import Topbar from './Topbar';
import Sidebar from './Sidebar';
import { MainLayoutProps } from '../../types/layout.types';

export default function MainLayout({ children }: MainLayoutProps) {
  const [isExpanded, setIsExpanded] = useState<boolean>(true);

  const toggleSidebar = () => {
    setIsExpanded(prev => !prev);
  };

  return (
    <div className="vh-100 w-100 d-flex flex-column overflow-hidden" id="main-layout-container">
      {/* Topbar layout block */}
      <Topbar />

      {/* Middle layout row containing both Sidebar and Main Viewport */}
      {/* A spacing margin-top of 70px ensures no overlapping with the fixed-top navigation */}
      <div className="d-flex flex-grow-1 overflow-hidden" style={{ marginTop: '70px' }} id="main-layout-body">
        
        {/* Sidebar Component */}
        <Sidebar isExpanded={isExpanded} onToggle={toggleSidebar} />

        {/* Primary Content Viewport with standalone scrolling */}
        <main className="flex-grow-1 bg-light overflow-y-auto p-2 p-md-4" id="main-content-wrapper">
          <div className="container-fluid px-1 px-sm-2 py-2">
            {children}
          </div>
          {/* Espaçador inferior no celular/tablet para prevenir que a BottomBar tampe conteúdos vitais */}
          <div className="d-block d-lg-none" style={{ height: '85px' }} />
        </main>
      </div>
    </div>
  );
}
